export default __webpack_public_path__ + "static/media/withlogo.006.751f803d.jpeg";